import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    codeProp: 'sfNo',
    detailIdProp: 'sfId',
    detailUrl: '/UcDetail',
    listUrl: '/UcList',
    mapProp: 'sfMap',
    name: '集成用例',
    textProp: 'sfName',
    type: 'UC',
}
